import { GA4_EVENT } from './events';

const isDev = process.env.NODE_ENV !== 'production';

const isGaDebugEnabled = () => {
  if (typeof window === 'undefined') return false;
  if (!isDev) return false;

  try {
    const fromQuery = new URLSearchParams(window.location.search).get('ga_debug') === '1';
    const fromStorage = window.localStorage?.getItem('ga_debug') === '1';
    return fromQuery || fromStorage;
  } catch {
    return false;
  }
};

const RECENT_EVENT_TTL_MS = 1500;
const recentEvents = new Map();

const stableStringifyShallow = (obj) => {
  if (!obj || typeof obj !== 'object') return String(obj);
  const keys = Object.keys(obj).sort();
  const normalized = {};
  for (const k of keys) normalized[k] = obj[k];
  return JSON.stringify(normalized);
};

const shouldSkipRecentDuplicate = (name, payload) => {
  if (!isDev) return false;

  const now = Date.now();
  const key = `${name}:${stableStringifyShallow(payload)}`;
  const last = recentEvents.get(key);
  if (typeof last === 'number' && now - last < RECENT_EVENT_TTL_MS) {
    return true;
  }
  recentEvents.set(key, now);
  return false;
};

const getPlatform = () => {
  const raw = typeof window !== 'undefined' ? window?.platform : undefined;
  if (raw === 'ios' || raw === 'android') return raw;
  return 'web';
};

const getAppContext = () => {
  const isApp = typeof window !== 'undefined' ? Boolean(window?.isApp) : false;
  return isApp ? 'rn_webview' : 'web';
};

const getCommonParams = () => ({
  platform: getPlatform(),
  app_context: getAppContext(),
});

const GA_ID = process.env.REACT_APP_GA_ID;

export const gaEvent = (name, params = {}) => {
  if (!GA_ID) return;
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;

  const payload = {
    ...getCommonParams(),
    ...params,
  };

  if (shouldSkipRecentDuplicate(name, payload)) return;

  if (isGaDebugEnabled()) {
    // eslint-disable-next-line no-console
    console.info('[GA4]', name, payload);
  }

  window.gtag('event', name, payload);
};

export const gaPageView = ({ page_path, page_title } = {}) => {
  if (!GA_ID) return;
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;

  const path = page_path ?? `${window.location.pathname}${window.location.search}`;
  const payload = {
    ...getCommonParams(),
    page_path: path,
    page_location: window.location.href,
    page_title: page_title ?? document.title,
  };

  if (shouldSkipRecentDuplicate(GA4_EVENT.PAGE_VIEW, payload)) return;

  if (isGaDebugEnabled()) {
    // eslint-disable-next-line no-console
    console.info('[GA4]', GA4_EVENT.PAGE_VIEW, payload);
  }

  window.gtag('event', GA4_EVENT.PAGE_VIEW, payload);
};

